export const API_URL = "https://forkify-api.herokuapp.com/api/v2/recipes/";
export const TIMEOUT_SEC = 10;
export const KEY = '8629c7a0-dda5-4a6c-8621-4d1631d268e1';